import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const useBrowserBackStack = () => {
  const location = useLocation();
  const [backStack, setBackStack] = useState<typeof location[]>([]);

  useEffect(() => {
    setBackStack((prevStack) => {
      const last = prevStack[prevStack.length - 1];
      if (!last || last.pathname !== location.pathname || last.search !== location.search) {
        return [...prevStack, location];
      }
      return prevStack;
    });
  }, [location]);

  return backStack;
};

export default useBrowserBackStack;